// Activate empty Judge.me v3 app blocks when they approach the viewport.
// The original app renders settings, metadata, widget markup and its own modules.
const sections = [...document.querySelectorAll('[data-apola-review-lazy]')];
const loads = new Map();

function assetUrl(name, base) {
  const url = new URL(name, base);
  if (!url.href.startsWith(base) || url.protocol !== 'https:') throw new Error('Invalid review asset URL');
  return url.href;
}

function loadAsset(url, kind) {
  if (loads.has(url)) return loads.get(url);
  const promise = new Promise((resolve, reject) => {
    const selector = kind === 'style' ? 'link[rel="stylesheet"]' : 'script[src]';
    const existing = [...document.querySelectorAll(selector)].find(node => (node.href || node.src) === url);
    if (existing) return resolve();
    const node = document.createElement(kind === 'style' ? 'link' : 'script');
    if (kind === 'style') { node.rel = 'stylesheet'; node.href = url; }
    else { node.src = url; if (kind === 'module') node.type = 'module'; node.async = true; }
    const timeout = setTimeout(() => { node.remove(); reject(new Error('Review asset timeout')); }, 15000);
    node.onload = () => { clearTimeout(timeout); resolve(); };
    node.onerror = () => { clearTimeout(timeout); node.remove(); reject(new Error('Review asset failed')); };
    document.head.appendChild(node);
  }).catch(error => { loads.delete(url); throw error; });
  loads.set(url, promise);
  return promise;
}

let activation;
function loadLegacy(name) {
  return new Promise((resolve, reject) => {
    const timeout = setTimeout(() => reject(new Error('Review helpers timeout')), 15000);
    window.jdgm.loadScript(name, () => { clearTimeout(timeout); resolve(); });
  });
}
async function activate() {
  if (activation) return activation;
  activation = (async () => {
    const base = window.jdgm?.CDN_BASE_URL;
    if (!base) throw new Error('Review configuration unavailable');
    const widgets = sections.map(section => section.querySelector('.apola-review-mount')).filter(Boolean);
    if (!widgets.length || widgets.length !== sections.length) throw new Error('Review markup changed');
    for (const widget of widgets) {
      widget.id = 'judgeme_product_reviews';
      widget.classList.add('jdgm-widget', 'jdgm-review-widget');
      widget.dataset.entryPoint = widget.dataset.apolaReviewEntryPoint;
      widget.dataset.widget = 'review';
    }
    sections.forEach(section => { section.setAttribute('aria-busy', 'true'); section.querySelector('button[data-apola-load-reviews]').textContent = 'Ładowanie opinii…'; });
    const response = await fetch(assetUrl('manifest.json', base));
    if (!response.ok) throw new Error('Review manifest unavailable');
    const manifest = await response.json();
    const prefix = window.jdgm.isVersion3 ? 'widget_v3_' : 'widget_';
    const css = new Set([assetUrl(prefix + 'base.css', base), assetUrl(prefix + 'main.css', base)]);
    const visited = new Set();
    function visit(key) {
      if (visited.has(key)) return;
      visited.add(key);
      const entry = manifest[key];
      if (!entry) return;
      (entry.css || []).forEach(name => css.add(assetUrl(name, base)));
      (entry.imports || []).forEach(visit);
    }
    widgets.forEach(widget => visit(widget.dataset.entryKey));
    await Promise.all([...css].map(url => loadAsset(url, 'style')));
    // Preserve Judge.me's legacy helpers used by its native write-review dialog.
    if (typeof window.jdgm.$ !== 'function') await loadLegacy('widget/base.js');
    if (typeof window.jdgm.initializeWidgets !== 'function') await loadLegacy('widget/common.js');
    const entries = new Set(widgets.map(widget => assetUrl(widget.dataset.entryPoint, base)));
    await Promise.all([...entries].map(url => loadAsset(url, 'module')));
    for (const section of sections) {
      section.setAttribute('aria-busy', 'false');
      section.querySelector('[data-apola-review-placeholder]').hidden = true;
    }
  })().catch(error => {
    activation = undefined;
    sections.forEach(section => {
      section.setAttribute('aria-busy', 'false');
      section.querySelector('button[data-apola-load-reviews]').textContent = 'Spróbuj ponownie załadować opinie';
    });
    console.error('APOLA reviews:', error);
  });
  return activation;
}

sections.forEach(section => section.querySelector('[data-apola-load-reviews]').addEventListener('click', activate));
if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); activate(); }
  }, { rootMargin: '500px' });
  sections.forEach(section => observer.observe(section));
} else activate();

const reviewLink = () => {
  if (/judgeme/.test(location.hash + location.search)) activate();
};
window.addEventListener('hashchange', reviewLink);
reviewLink();
